<fieldset>
  <legend>Znalec</legend>
  <div class="column-100">
    <gmt-input label="Znalec" [required]="true">
      <gmt-select
        [data]="this"
        field="expert"
        resource="experts"
        [itemPipe]="expertNamePipe"
        [reloadOptionsRegister]="expertsReloadRegister"
        (changed)="onChange()"
      ></gmt-select>
      <gmt-button *ngIf="!!expert" [clickAction]="onUpdateExpert" [title]="'Upravit znalce'"><span class="fa fa-pencil"></span></gmt-button>
      <gmt-button [clickAction]="onAddExpert" [title]="'Nový znalec'"><span class="fa fa-plus"></span></gmt-button>
    </gmt-input>
  </div>
</fieldset>
